/* DON'T EDIT THIS FILE: edit original and run build again */ export const dniSeparator = ".";
export const dummyDniNormalPrefix = "T1";
export const dummyDniMissingPrefix = "T3";
export const dummyDniErrorPrefix = "T4";
export const dummyDniAmbiguousPrefix = "T5";
